import { t } from "@travily/i18n";
import { Icon } from "@ui/components/Icon";
import { IconActionLink } from "@ui/components/IconActionLink";

export interface NotificationsActionProps {
  href: string;
  /** Number of unseen notifications. Renders a badge when greater than zero. */
  unseenCount?: number;
}

export function NotificationsAction({ href, unseenCount = 0 }: NotificationsActionProps) {
  const ariaLabel =
    unseenCount > 0
      ? t("components.views.shared.notifications_action.unseen_label", { count: unseenCount })
      : t("components.views.shared.notifications_action.label");

  return (
    <IconActionLink ariaLabel={ariaLabel} badgeCount={unseenCount} href={href}>
      <Icon name="bell" size="32" type="sticker" />
    </IconActionLink>
  );
}
